import React, { useCallback, useState } from 'react';
import * as moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch, useSelector, connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

import './DatabaseSearch.scss';

// import { EMAIL_REGEX } from '../../../constants/regex-validations';
import Input from '../../atoms/Input/Input';
import Button from '../../atoms/Button/Button';
import DropDown from '../../atoms/DropDown/DropDown';
import Icon from '../../atoms/Icon/Icon';

import States from '../../../Constants/states.json';

import { fetchPeopleContact } from '../../../Apis/actions/person-search-actions';

import Modal from '../../atoms/Modal/Modal';

const DatabaseSearch = ({ setCustomRequest, persistedSearchTerms }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoadingPeopleContacts, people } = useSelector((state) => state.personSearchReducer);

  const [showManyResultsPopup, setShowManyResultPopup] = useState(false);
  const [formError, setFormError] = useState('');

  // const [advanceFormValues, setAdvanceFormValues] = useState({
  //   LicenseState: people?.search_query?.LicenseState || '',
  //   License: people?.search_query?.License || '',
  //   BusinessName: people?.search_query?.BusinessName || '',
  //   BusinessState: people?.search_query?.BusinessState || ''
  // });

  const [formValues, setFormValues] = useState({
    FirstName: people?.search_query?.FirstName || persistedSearchTerms?.FirstName || '',
    LastName: people?.search_query?.LastName || '',
    MiddleName: people?.search_query?.MiddleName || '',
    Akas: people?.search_query?.Akas || '',
    Dob: people?.search_query?.Dob || '',
    Age: people?.search_query?.Age || '',
    AgeRange: people?.search_query?.AgeRangeMinAge
      ? `${people?.search_query?.AgeRangeMinAge}-${people?.search_query?.AgeRangeMaxAge}`
      : '',
    Address: people?.search_query?.Address || '',
    City: people?.search_query?.City || '',
    State: people?.search_query?.State || '',
    Zip: people?.search_query?.Zip || '',
    Email: people?.search_query?.Email || '',
    Phone: people?.search_query?.Phone || '',
    ReversePhone: people?.search_query?.ReversePhone || ''
  });

  const [advanceFormValues, setAdvanceFormValues] = useState({
    PreviousCity: people?.search_query?.PreviousCity || '',
    PreviousState: people?.search_query?.PreviousState || '',
    RelativeFirstName: people?.search_query?.RelativeFirstName || '',
    RelativeLastName: people?.search_query?.RelativeLastName || ''
  });
  // const disableAdvanceDBSearchInputs = !!Object.values(formValues).find((e) => e !== '');
  // const disableDBSearchInputs = !!Object.values(advanceFormValues).find((e) => e !== '');

  const allformValues = { ...formValues, ...advanceFormValues };
  const validateEmptyForm = Object.values(allformValues).filter((e) => e !== '').length === 0;
  const validateRequiredFields =
    (Object.values(allformValues).filter((e) => e !== '').length === 1 &&
      allformValues.City !== '') ||
    (Object.values(allformValues).filter((e) => e !== '').length === 1 &&
      allformValues.State !== '') ||
    (Object.values(allformValues).filter((e) => e !== '').length === 1 &&
      allformValues.Zip !== '') ||
    (Object.values(allformValues).filter((e) => e !== '').length === 1 &&
      allformValues.AgeRange !== '');

  const validateAddressForm = formValues.Address !== '' && formValues.State === '';
  const validateAdvancedSearch = Object.values(formValues).filter((e) => e !== '').length === 0;

  const submitCallback = useCallback(
    (event) => {
      event.preventDefault();
      if (validateAddressForm) {
        window.scrollTo({
          top: 0,
          left: 0
        });
        return setFormError('State required');
      }

      if (validateRequiredFields) {
        window.scrollTo({
          top: 0,
          left: 0
        });
        return setFormError('Additional field required');
      }

      if (validateAdvancedSearch) {
        window.scrollTo({
          top: 0,
          left: 0
        });
        return setFormError('Please provide Name, Contact Info or Address');
      }

      setFormError('');
      // const redirectUrlCallback = () => navigate('/contact-detail', { ...formValues });
      const redirectUrlCallback = () => {
        // navigate('/contact-detail', {
        //   replace: true,
        //   state: {
        //     ...formValues
        //   }
        // });
        navigate('/contact-detail', { state: { ...formValues } });

        // navigate('/contact-detail', { ...formValues });
      };
      const isEmailPresent = JSON.parse(localStorage.getItem('userData'))?.email;
      const isTokenPresent = JSON.parse(localStorage.getItem('userData'))?.token;
      const formData = {
        ...formValues,
        ...advanceFormValues,
        // ...advanceFormValues,
        AddressLine1: formValues.Address,
        AddressLine2: `${formValues.City}${
          formValues.City !== '' && formValues.State !== '' ? ',' : ''
        }${formValues.State} ${formValues.Zip}`,
        AgeRangeMinAge: formValues.AgeRange.split('-')[0],
        AgeRangeMaxAge: formValues.AgeRange.split('-')[1],
        Dob: formValues.Dob !== '' ? moment(formValues.Dob).format('MM/DD/YYYY') : formValues.Dob,
        page: { current: 1, size: 20 },
        email: isEmailPresent,
        token: isTokenPresent
      };

      dispatch(fetchPeopleContact(formData, redirectUrlCallback, setShowManyResultPopup));
    },
    [
      dispatch,
      formValues,
      navigate,
      validateAddressForm,
      validateRequiredFields,
      advanceFormValues,
      validateAdvancedSearch
      // redirectUrlCallback
    ]
  );

  const formattedSubject = 'Request for a contact not found in the Search Engine';
  const mailToLink =
    'mailto:bot-user-sending-us-m-aaaaqcwxmgi4evf6kftva3jjou@tmxnews.slack.com?subject=' +
    encodeURIComponent(formattedSubject);

  return (
    <>
      {showManyResultsPopup ? (
        <Modal
          close={() => setShowManyResultPopup(false)}
          closeIcon
          customModalWrapper={'tmx-dbSearch__customModalWrapper'}
          contentClassName={'tmx-dbSearch__modal'}
          title="More details needed">
          <div>
            Your search is too broad with over 100 results. Provide more detail for more accurate
            results.
          </div>
          <div className="tmx-dbSearch__manyResultModalBtnContainer">
            <Button
              className="tmx-dbSearch__manyResultBtn"
              buttonType="blue"
              handleClick={() => {
                setShowManyResultPopup(false);
                window.scrollTo({
                  top: 0,
                  left: 0
                });
              }}>
              Add more details
            </Button>
            <Button
              className="tmx-dbSearch__manyResultBtn tmx-dbSearch__manyResultBtn--white"
              buttonType="blue"
              handleClick={() => {
                setShowManyResultPopup(false);
              }}>
              Got it, thanks
            </Button>
          </div>
        </Modal>
      ) : null}

      <section className="tmx-dbSearch">
        <div onClick={() => navigate('/')} className="tmx-dbSearch__backButtonContainer">
          <div className="tmx-dbSearch__backButton">
            <Icon name="arrow-right" className="tmx-dbSearch__backButtonIcon" size="ginormous" />
            <div>Return to chat</div>
          </div>
        </div>
        <div className="tmx-dbSearch__headerContainer">
          <p className={classNames('tmx-dbSearch__header1')}>Regular Person search.</p>
        </div>
        <form className="tmx-dbSearch__form" onSubmit={submitCallback}>
          <section className="tmx-dbSearch__contact">
            {formError && <p className="tmx-dbSearch__formError">{formError}</p>}
            <hr></hr>
            <section className="tmx-dbSearch__contactForm name">
              <div className="tmx-dbSearch__sectionLabel">1. Name and Age</div>
              <div className="tmx-dbSearch__inputSectionContainer">
                <div className="tmx-dbSearch__inputContainer">
                  <Input
                    id="FirstName"
                    type="text"
                    placeholder="First Name"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, FirstName: event.target.value });
                    }}
                    value={formValues['FirstName']}
                    darkBorder
                    label="First Name:"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="LastName"
                    type="text"
                    placeholder="Last Name"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, LastName: event.target.value });
                    }}
                    value={formValues['LastName']}
                    darkBorder
                    label="Last Name:"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="MiddleName"
                    type="text"
                    placeholder="Middle Name"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, MiddleName: event.target.value });
                    }}
                    value={formValues['MiddleName']}
                    darkBorder
                    label="Middle Name:"
                    // disabled={disableDBSearchInputs}
                  />
                </div>

                <div className="tmx-dbSearch__inputContainer">
                  <Input
                    id="DOB"
                    type="date"
                    placeholder="DOB"
                    max={new Date().toISOString().split('T')[0]}
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, Dob: event.target.value });
                    }}
                    value={formValues['Dob']}
                    darkBorder
                    label="DOB:"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="AgeRange"
                    type="text"
                    placeholder="Age Range (E.g. 25-30)"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, AgeRange: event.target.value });
                    }}
                    value={formValues['AgeRange']}
                    darkBorder
                    label="Age Range:"
                    // disabled={disableDBSearchInputs}
                  />
                </div>
              </div>
            </section>

            <hr></hr>
            <section className="tmx-dbSearch__contactForm name">
              <div className="tmx-dbSearch__sectionLabel">2. Contact Info</div>
              <div className="tmx-dbSearch__inputSectionContainer">
                <div className="tmx-dbSearch__inputContainer">
                  <Input
                    id="Phone"
                    type="text"
                    placeholder="Phone Number"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, Phone: event.target.value });
                    }}
                    value={formValues['Phone']}
                    darkBorder
                    label="Phone:"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="Email"
                    type="text"
                    placeholder="Email Address"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, Email: event.target.value });
                    }}
                    value={formValues['Email']}
                    darkBorder
                    label="Email:"
                    // disabled={disableDBSearchInputs}
                  />
                </div>
              </div>
            </section>

            <hr></hr>
            <section className="tmx-dbSearch__contactForm name">
              <div className="tmx-dbSearch__sectionLabel">3. Lives In</div>
              <div className="tmx-dbSearch__inputSectionContainer">
                <div className="tmx-dbSearch__inputContainer">
                  <Input
                    id="Address"
                    type="text"
                    placeholder="Street Address"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, Address: event.target.value });
                    }}
                    value={formValues['Address']}
                    darkBorder
                    label="Address:"
                    // disabled={disableDBSearchInputs}
                  />

                  <Input
                    id="Zip"
                    type="text"
                    placeholder="Zip"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, Zip: event.target.value });
                    }}
                    value={formValues['Zip']}
                    darkBorder
                    label="Zip:"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="City"
                    type="text"
                    placeholder="City"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setFormValues({ ...formValues, City: event.target.value });
                    }}
                    value={formValues['City']}
                    darkBorder
                    label="City:"
                    // disabled={disableDBSearchInputs}
                  />
                  <div className="tmx-dbSearch__select">
                    <p>State:</p>
                    <DropDown
                      onChange={(event) => {
                        if (event.target.value !== 'Select State')
                          setFormValues({ ...formValues, State: event.target.value });
                      }}
                      className="tmx-dbSearch__dropDown"
                      data={Object.values(States)}
                      name="Select State"
                      value={formValues.State}
                      // disabled={disableDBSearchInputs}
                    />
                  </div>
                </div>
              </div>
            </section>

            <hr></hr>
            <section className="tmx-dbSearch__contactForm name">
              <div className="tmx-dbSearch__sectionLabel">4. Helpful Details</div>
              <div className="tmx-dbSearch__inputSectionContainer">
                <div className="tmx-dbSearch__inputContainer">
                  <Input
                    id="PreviousCity"
                    type="text"
                    placeholder="City"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setAdvanceFormValues({
                        ...advanceFormValues,
                        PreviousCity: event.target.value
                      });
                    }}
                    value={advanceFormValues['PreviousCity']}
                    darkBorder
                    label="Previously Lived City"
                    // disabled={disableDBSearchInputs}
                  />

                  <div className="tmx-dbSearch__select">
                    <p>Previously Lived State</p>
                    <DropDown
                      onChange={(event) => {
                        if (event.target.value !== 'Select State')
                          setAdvanceFormValues({
                            ...advanceFormValues,
                            PreviousState: event.target.value
                          });
                      }}
                      className="tmx-dbSearch__dropDown"
                      data={Object.values(States)}
                      name="Select State"
                      value={advanceFormValues.PreviousState}
                      // disabled={disableDBSearchInputs}
                    />
                  </div>

                  <Input
                    id="RelativeFirstName"
                    type="text"
                    placeholder="First Name"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setAdvanceFormValues({
                        ...advanceFormValues,
                        RelativeFirstName: event.target.value
                      });
                    }}
                    value={advanceFormValues['RelativeFirstName']}
                    darkBorder
                    label="Relative’s First Name"
                    // disabled={disableDBSearchInputs}
                  />
                  <Input
                    id="RelativeLastName"
                    type="text"
                    placeholder="Last Name"
                    className="tmx-registerForm__input"
                    onChange={(event) => {
                      setAdvanceFormValues({
                        ...advanceFormValues,
                        RelativeLastName: event.target.value
                      });
                    }}
                    value={advanceFormValues['RelativeLastName']}
                    darkBorder
                    label="Relative’s Last Name"
                    // disabled={disableDBSearchInputs}
                  />
                </div>
              </div>
            </section>
          </section>

          <Button
            className="tmx-dbSearch__joinTmxButton"
            buttonIcon={isLoadingPeopleContacts ? '' : 'search'}
            buttonType="blue"
            spinner={isLoadingPeopleContacts}
            disabled={isLoadingPeopleContacts || validateEmptyForm}
            type="submit">
            {isLoadingPeopleContacts ? 'Loading' : 'Search'}
          </Button>

          <p className="tmx-dbSearch__findCustom">
            Can&apos;t find a contact?{' '}
            <span
              className="tmx-dbSearch__CustomBtn"
              onClick={() => window.open(mailToLink, '_self')}
              onKeyDown={() => window.open(mailToLink, '_self')}
              tabIndex={0}
              role="button">
              let us know.
            </span>
          </p>
        </form>
      </section>
    </>
  );
};

DatabaseSearch.propTypes = {
  setCustomRequest: PropTypes.func,
  signIn: PropTypes.any,
  signUp: PropTypes.any,
  linkOrgFromSignIn: PropTypes.any,
  persistedSearchTerms: PropTypes.shape({ FirstName: PropTypes.string, LastName: PropTypes.string })
};

function mapStateToProps(state) {
  return {
    signIn: state.signInReducer,
    linkOrgFromSignIn: state.signInReducer,
    signUp: state.signUpReducer
  };
}

export default connect(mapStateToProps)(DatabaseSearch);
